import React, { createContext, useContext } from 'react';
import { useNavigate } from 'react-router-dom';

const NavigationBlockerContext = createContext();

/**
 * Simplified navigation blocker provider
 * Components should handle their own unsaved changes logic
 */
export const NavigationBlockerProvider = ({ children }) => {
  const navigate = useNavigate();

  const value = {
    navigate, // Pass through the regular navigate function
    // Components can add their own blocking logic as needed
    registerBlocker: () => {}, // No-op for now
    unregisterBlocker: () => {}, // No-op for now
    hasUnsavedChanges: () => false // Always return false for now
  };

  return (
    <NavigationBlockerContext.Provider value={value}>
      {children}
    </NavigationBlockerContext.Provider>
  );
};

/**
 * Hook to use the navigation blocker context
 */
export const useNavigationBlocker = () => {
  const context = useContext(NavigationBlockerContext);
  if (!context) {
    // If not within provider, just return a mock object with navigate
    return {
      navigate: () => {},
      registerBlocker: () => {},
      unregisterBlocker: () => {},
      hasUnsavedChanges: () => false
    };
  }
  return context;
};